/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/ban-types */
// vendor modules
import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import { Button } from "QuorumDesign"

import {
    StyledSearchifyActionButtons,
    StyledSearchifyActionButtonsContainer,
} from "app/static/frontend/search-new/components/FilterableListView/Searchify/SearchifyActionButtons/style"

// selectors
import { selectIsCountLoading } from "shared/search/selectors"
import {
    selectIsFilterOnlySearchify,
    selectIsSearchifyCountLoading,
    selectIsSearchifySelectAllActionButtonEnabled,
    selectIsSearchifySelectAllDisabled,
    selectSearchifyCount,
    selectSearchifyShowingCurrentSelection,
} from "shared/search/searchify/selectors"
import { selectSearchShouldHideFilters } from "shared/userdata/userdata-selectors"

// action creators
import { sendAction } from "shared/djangio/action-creators"
import { updateUserdata } from "shared/userdata/userdata-action-creators"
import {
    clearSearchifySelections,
    toggleShowSearchifyCurrentSelection,
    searchifyAddCurrentFilter,
} from "shared/search/searchify/action-creators"
import { toggleHideFilterSet } from "app/static/frontend/search-new/action-creators"

import { QuorumTheme } from "app/static/frontend/design-constants"

const mapStateToProps = createStructuredSelector({
    countIsLoading: selectIsCountLoading,
    isFilterOnlySearchify: selectIsFilterOnlySearchify,
    isSearchifySelectAllActionButtonEnabled: selectIsSearchifySelectAllActionButtonEnabled,
    isSearchifySelectAllDisabled: selectIsSearchifySelectAllDisabled,
    searchifyCount: selectSearchifyCount,
    searchifyCountIsLoading: selectIsSearchifyCountLoading,
    searchifyShowingSelected: selectSearchifyShowingCurrentSelection,
    shouldHideFilters: selectSearchShouldHideFilters,
})

const mapDispatchToProps = {
    clearSearchifySelections,
    searchifyAddCurrentFilter,
    sendAction,
    toggleShowSearchifyCurrentSelection,
    updateUserdata,
}

export function SearchifyActionButtons(props) {
    /** ****************************************************************************
     *
     * Searchify Action Creator Logic: on selecting a button, close the menu, if open.
     *
     ****************************************************************************** */
    const boundClearSearchifySelections = () => props.clearSearchifySelections(props.uniqueFlvId)
    const boundToggleShowSearchifyCurrentSelection = () => {
        if (!props.countIsLoading && !props.searchifyCountIsLoading) {
            props.toggleShowSearchifyCurrentSelection(props.uniqueFlvId)
        }
    }
    const boundSearchifyAddCurrentFilter = () => props.searchifyAddCurrentFilter(props.uniqueFlvId)

    return (
        <StyledSearchifyActionButtonsContainer shouldHideFilters={props.shouldHideFilters} isMobile={props.isMobile}>
            {props.shouldHideFilters && (
                <Button
                    isTiny
                    leftIcon="arrow-from-left"
                    leftIconFamily="far"
                    leftIconFlip={!props.shouldHideFilters && "horizontal"}
                    leftIconSize="18px"
                    leftIconStyle={{ display: "block" }}
                    onClick={() => {
                        toggleHideFilterSet({
                            sendAction: props.sendAction,
                            shouldHideFilters: !props.shouldHideFilters,
                            updateUserdata: props.updateUserdata,
                        })
                    }}
                    text={props.shouldHideFilters ? "Show" : "Hide"}
                    type="outlined"
                />
            )}
            <StyledSearchifyActionButtons>
                <Button
                    dataCy="SearchifyActionButtonsShowSelected"
                    disabled={!props.searchifyCount}
                    isTiny
                    onClick={boundToggleShowSearchifyCurrentSelection}
                    style={{
                        marginLeft: props.isMobile ? "" : "11px",
                    }}
                    text={props.searchifyShowingSelected ? "Hide Selected" : "Show Selected"}
                    type="outlined"
                />
                <Button
                    dataCy="SearchifyActionButtonsClearSelected"
                    disabled={!props.searchifyCount}
                    isTiny
                    onClick={boundClearSearchifySelections}
                    style={{
                        marginLeft: props.isMobile ? "0.5rem" : "11px",
                    }}
                    text="Clear Selections"
                    type="outlined"
                />
                {
                    // we only want to render the "Select All" button for Sheet Power Searches
                    // see app/static/frontend/sheets/components/SheetsSearchifyWrapper.jsx
                    // searchifyConfigs enableSelectAllSearchify
                    !props.isSearchifySelectAllDisabled &&
                        !props.searchifyShowingSelected &&
                        props.isSearchifySelectAllActionButtonEnabled && (
                            <Button
                                dataCy="SearchifyActionButtonsSelectAll"
                                // https://github.com/QuorumUS/quorum-site/pull/19017
                                isTiny
                                onClick={boundSearchifyAddCurrentFilter}
                                style={{
                                    marginLeft: props.isMobile ? "0.5rem" : "11px",
                                }}
                                text="Select All"
                                type="outlined"
                            />
                        )
                }
            </StyledSearchifyActionButtons>
            {props.isMobile && props.hasFilterGroups && (
                <Button
                    style={{ color: QuorumTheme.colors.gray[7] }}
                    onClick={() => props.setMobileFiltersOpenStatus(true)}
                    rightIcon="filter"
                    rightIconFamily="far"
                    type="borderless"
                    rightPadding="0.5rem"
                />
            )}
        </StyledSearchifyActionButtonsContainer>
    )
}

SearchifyActionButtons.propTypes = {
    clearSearchifySelections: PropTypes.func.isRequired,
    countIsLoading: PropTypes.bool.isRequired,
    isFilterOnlySearchify: PropTypes.bool.isRequired,
    isSearchifySelectAllActionButtonEnabled: PropTypes.bool,
    isSearchifySelectAllDisabled: PropTypes.bool.isRequired,
    searchifyAddCurrentFilter: PropTypes.func.isRequired,
    searchifyCount: PropTypes.number,
    searchifyCountIsLoading: PropTypes.bool.isRequired,
    searchifyShowingSelected: PropTypes.bool.isRequired,
    sendAction: PropTypes.func.isRequired,
    shouldHideFilters: PropTypes.bool,
    toggleShowSearchifyCurrentSelection: PropTypes.func.isRequired,
    uniqueFlvId: PropTypes.string.isRequired,
    updateUserdata: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(withImmutablePropsToJS(SearchifyActionButtons))
